import axios from 'axios';
import { getUserToken } from '../../utils/localStoarege';
import { adminStatsUrl, allCentersTptUrl, appServerLocalToken, branchWiseStatsUrl, doctorFinancialStatsUrl, doctorPackageStats, getDoctorPackageInvoice, hudDashboardGetApi, invoiceFinancialDataGetApi, invoiceHftDataGetApi, monthlyPatientSummaryUrl, newClinicLocalToken, revenueSummaryUrl, tptDosesLastHourUrl } from '../../constants/apis/doctor_apis';
import { centersApi, invoiceVerificationOtpMachine, performLockDeviceCenterMachine } from '../../constants/apis/clinic_apis';

export const getDoctorCenters = async (query) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token 06ff9dbd57ede946caf4e3210a929157c40c8e47`,
        },
    };
    const response = await axios.get(centersApi + query || "", config);
    return response;
};

export const getDoctorPatientsGraph = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${newClinicLocalToken}`,
        },
    };
    const response = await axios.get(monthlyPatientSummaryUrl, config);
    return response;
};

export const getDoctorAdminStats = async (filters) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${newClinicLocalToken}`,
        },
    };
    const response = await axios.get(adminStatsUrl + filters ?? "", config);
    return response;
};

export const getBranchWiseDoctorStats = async ({ branch, filters }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${newClinicLocalToken}`,
        },
    };
    const response = await axios.get(branchWiseStatsUrl + (branch ?? "") + (filters ?? ""), config);
    return response;
};

export const getDoctorDashboardFinancialData = async ({ branch, filters }) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${appServerLocalToken}`,
        },
    };
    const response = await axios.get(doctorFinancialStatsUrl + (branch ?? "") + (filters ?? ""), config);
    return response;
};

export const getHudDoctorDashboard = async (days, filter) => {
    const token = appServerLocalToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(invoiceFinancialDataGetApi + `${days ? "?days=" + days : ""}` + `${filter ?? ""}`, config);
    return response;
};

export const getHudDoctorHudData = async () => {
    const token = appServerLocalToken;
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(invoiceHftDataGetApi, config);
    return response;
};

export const getHudDoctorHudViewData = async () => {
    const token = getUserToken();
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${token}`,
        },
    };
    const response = await axios.get(hudDashboardGetApi, config);
    return response;
};


export const getRevenueSummary = async ({ month, center } = {}) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${appServerLocalToken}`,
        },
    };
    const params = new URLSearchParams();
    if (month) params.append("month", month);
    if (center) params.append("center", center);
    const query = params.toString();
    const response = await axios.get(revenueSummaryUrl + (query ? `?${query}` : ""), config);
    return response;
};

export const getAllCentersTpt = async () => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${appServerLocalToken}`,
        },
    };
    const response = await axios.get(allCentersTptUrl, config);
    return response;
};

export const getTptDosesLastHour = async ({ hours, branch } = {}) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${newClinicLocalToken}`,
        },
    };
    const params = new URLSearchParams();
    if (hours) params.append("hours", hours);
    if (branch) params.append("branch_name", branch);
    const query = params.toString();
    const response = await axios.get(tptDosesLastHourUrl + (query ? `?${query}` : ""), config);
    return response;
};

export const operateTptMachineDoor = async (id, isDoor) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${appServerLocalToken}`,
        },
    };
    const response = await axios.patch(
        performLockDeviceCenterMachine + id + "/",
        { is_door: isDoor },
        config
    );
    return response;
};

export const getDoctorInvoices = async (centerName) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token 06ff9dbd57ede946caf4e3210a929157c40c8e47`,
        },
    };
    const response = await axios.get(getDoctorPackageInvoice + centerName, config);
    return response;
};

export const getDoctorInvoiceStats = async (centerName) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token 06ff9dbd57ede946caf4e3210a929157c40c8e47`,
        },
    };
    const response = await axios.get(doctorPackageStats + centerName + "/", config);
    return response;
};

export const sendMonthlyStatsOtp = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Token ${appServerLocalToken}`,
        },
    };
    const response = await axios.post(invoiceVerificationOtpMachine, data, config);
    return response;
};
